




























import { Component, Prop, Vue } from 'vue-property-decorator'

import { EmptyState } from '@/layouts/components'

@Component({
  components: {
    EmptyState
  }
})
export default class NetworkErrorEmptyState extends Vue {
  @Prop({ type: String, required: true })
  readonly label!: string

  checkDefaultSlot () {
    return this.$slots.default !== undefined
  }
}
